import axios from 'axios'
import { Message } from 'element-ui'
import md5 from './md5'
import queryString from 'query-string'

const instance = axios.create({
  timeout: 10000,
})

function getToken() {
  const parsedHash = queryString.parse(location.hash)
  const theUrl = location.href.split('?')[1]
  const parsed = queryString.parse(theUrl)
  const token = parsed.token
  return token
}

function getHeaders() {
  const davinciKey = 'davinci.xiaoyibang'
  const nonceStr = new Date().getTime() % 100000
  const sign = md5(nonceStr + davinciKey)
  return { sign, nonceStr }
}

instance.interceptors.request.use(function(config) {
  const customHeaders = getHeaders()
  config.headers = {
    token: getToken(),
    ...customHeaders,
    ...config.headers,
  }
  return config
})

instance.interceptors.response.use(function(res) {
  const { message, code, data } = res.data
  if (code == '500' || code == '000') {
    Message.error(message)
    return Promise.reject(message)
  } else {
    return Promise.resolve(data)
  }
})

export default instance
